import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setTurnAroundFactorsOptions } from '../store/options.actions'
import { moveOptionToEnd } from '../../../utilities/options.util'

export function* getTurnAroundFactorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getTurnAroundFactorsOptions])
    const { entity } = response
    moveOptionToEnd(entity, 365)
    yield put(setTurnAroundFactorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getTurnAroundFactorsOptions() error: ${e}`))
  }
}

export function* getTurnAroundFactorsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getTurnAroundFactorsOptions)
}
